import { IconButton,} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

type props = {
    value: string, 
    fontSize?: "small" | "inherit" | "large" | "medium",
    color?: string
}

const CopyTxtIconBtn = ({value}: props) => {
    const clicked = () => {
        navigator.clipboard.writeText(value);
    }
    return (
        <IconButton aria-label="copy" onClick={clicked} >
        <ContentCopyIcon fontSize="small" />
    </IconButton>
  )
}

export default CopyTxtIconBtn;